import { heroFeatured, heroSideCards } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section className="w-full bg-gradient-to-b from-primary-100/70 via-background-50 to-background-50">
      <div className="mx-auto w-full px-4 pb-10 pt-8 md:px-6 md:pb-14 md:pt-12">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-200/80 px-3 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-fire-line text-sm"></i>
              绯闻 · 私密 · 不雅事件瓜料汇总
            </span>
            <h1 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
              美丽的小蜜桃黑料爆料瓜汇总
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              绯闻、私密与不雅事件的瓜料线索都在这里集中梳理。不论你想追最新爆料，还是回头翻一翻过往争议，都能顺着时间线找到出处与讨论。
            </p>
          </div>
          <div className="flex flex-wrap gap-2.5">
            <a
              href="#latest"
              className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 cursor-pointer"
            >
              <i className="ri-flashlight-line text-base"></i>
              看最新爆料
            </a>
            <a
              href="#topics"
              className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 text-sm font-semibold text-primary-800 transition-colors hover:bg-primary-100 cursor-pointer"
            >
              <i className="ri-price-tag-3-line text-base"></i>
              逛话题墙
            </a>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-3">
          <article className="group relative overflow-hidden rounded-lg lg:col-span-2">
            <div className="h-64 w-full md:h-80 lg:h-full lg:min-h-[360px]">
              <img
                src={heroFeatured.image}
                alt="美丽的小蜜桃重点追踪话题封面"
                title="重点追踪 · 事件脉络"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/35 to-black/10"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <span className="inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50 dark:text-foreground-950">
                <i className="ri-focus-3-line text-sm"></i>
                {heroFeatured.badge}
              </span>
              <h2 className="mt-3 font-heading text-xl font-black leading-snug text-white md:text-2xl">
                {heroFeatured.title}
              </h2>
              <p className="mt-2 hidden max-w-xl text-sm leading-relaxed text-white/85 sm:block">
                {heroFeatured.desc}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-white/80">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line text-sm"></i>
                  {heroFeatured.meta.time}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-fill text-sm text-accent-400"></i>
                  {heroFeatured.meta.heat}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-shield-check-line text-sm"></i>
                  {heroFeatured.meta.source}
                </span>
              </div>
            </div>
          </article>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
            {heroSideCards.map((card) => (
              <a
                key={card.id}
                href={card.href}
                className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
              >
                <div className="relative h-32 w-full">
                  <img
                    src={card.image}
                    alt={card.title}
                    title={card.title}
                    className="h-full w-full object-cover object-top"
                  />
                  <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2 py-0.5 text-[11px] font-bold text-primary-800 backdrop-blur">
                    {card.badge}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {card.title}
                  </h3>
                  <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {card.time}
                    </span>
                    <span className="flex items-center gap-1 font-semibold text-accent-700">
                      <i className="ri-fire-fill"></i>
                      {card.heat}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}